import styled from "styled-components";
import { themes } from "../../Utils/themes";
import { device } from "../../Utils/device";

export const CalendarSettingModalWrap = styled.section`
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  z-index: 99999;
`;

export const PurchasedModalContents = styled.div`
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  height: fit-content;
  background-color: ${themes.colors.white};
  border: 1px solid ${themes.colors.border};
  border-radius: 8px;
  z-index: 10;
  width: 90%;
  @media ${device.desktop} {
    width: 80%;
    max-width: 1000px;
  }
`;

export const ContentsWrap = styled.div`
  margin: 10px 20px;
  height: inherit;
  display: flex;
  flex-flow: column;
  justify-content: center;
  @media ${device.tablet} {
    margin: 15px 40px;
  }
  @media ${device.desktop} {
    margin: 20px 80px;
  }
`;

export const SelectedNameWrap = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border-bottom: 1px;
  text-decoration: underline;
  text-decoration-style: dotted;
  text-underline-offset: 8px;
`;

export const SelectedNameLabel = styled.h3`
  font-size: ${themes.textSize.m3};
  @media ${device.tablet} {
    font-size: ${themes.textSize.l2};
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.l2};
  }
`;

export const SelectedGBLabel = styled.h3`
  font-size: ${themes.textSize.m3};
  margin-left: 20px;
  @media ${device.tablet} {
    font-size: ${themes.textSize.l2};
    margin-left: 25px;
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.l2};
    margin-left: 30px;
  }
`;

export const SelectedSpecWrap = styled.div`
  display: block;
  margin: 0;
  @media ${device.tablet} {
    margin: 0 40px;
  }
  @media ${device.desktop} {
  }
`;

export const SelectedSpecItem = styled.div`
  display: flex;
  align-items: end;
  justify-content: space-between;
  padding: 10px 0;
  @media ${device.tablet} {
    font-size: ${themes.textSize.l1};
    margin: 20px 0 0;
    padding: 5px 20px 10px 0;
  }

  @media ${device.desktop} {
  }
`;
export const Border = styled.div`
  border-bottom: 1px solid ${themes.colors.border};
  @media ${device.tablet} {
  }

  @media ${device.desktop} {
  }
`;

export const PurchasedRequest = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px;
  color: ${themes.colors.white};
  border-radius: 10px;
  cursor: pointer;
  background-color: ${themes.colors.filled};
  white-space: nowrap;
  text-align: center;
  height: fit-content;
  font-size: ${themes.textSize.s3};
  max-width: 95px;
  width: 100%;
  font-weight: bold;
  @media ${device.tablet} {
    width: 100%;
    height: fit-content;
    margin: 10px 10px 0;
    font-size: ${themes.textSize.m1};
    max-width: 150px;
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.m2};
  }

  &:hover {
    opacity: 0.7;
  }
`;

export const PriceLabelWrap = styled.div`
  @media ${device.tablet} {
  }
`;

export const SpecLabel = styled.label`
  display: block;
  color: ${themes.colors.text};
  font-size: ${themes.textSize.m3};
  font-weight: bold;
  max-width: 400px;
  margin-top: 10px;
  @media ${device.tablet} {
    font-size: ${themes.textSize.l1};
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.l1};
  }
`;

export const SpecLabelDescription = styled.label`
  display: block;
  color: ${themes.colors.text};
  font-size: ${themes.textSize.s1};
  @media ${device.tablet} {
    font-size: ${themes.textSize.s2};
  }
  @media ${device.desktop} {
    font-size: ${themes.textSize.s3};
  }
`;

export const AppealPriceLabel = styled.label`
  display: block;
  margin: 10px auto 0;
  color: ${themes.colors.white};
  background-color: ${themes.colors.filled};
  font-size: ${themes.textSize.s3};
  font-weight: bold;
  padding: 5px;
  @media ${device.tablet} {
    font-size: ${themes.textSize.l2};
  }
`;

export const PriceLabel = styled.label`
  display: block;
  color: ${themes.colors.filled};
  font-size: ${themes.textSize.m3};
  font-weight: bold;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m3};
  }
  @media ${device.tablet} {
    font-size: ${themes.textSize.l1};
  }
`;

export const PriceTextLabel = styled.label`
  display: block;
  color: ${themes.colors.filled};
  font-size: ${themes.textSize.m1};
  font-weight: bold;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m3};
  }
`;

export const DoubleLinePriceLabel = styled.label`
  display: block;
  color: ${themes.colors.text};
  font-size: ${themes.textSize.m1};
  text-decoration: line-through;
  text-align: end;
  @media ${device.tablet} {
    font-size: ${themes.textSize.m2};
  }
`;

export const ModalCloseButton = styled.button`
  position: absolute;
  top: 10px;
  right: 6px;
  border: 1px solid ${themes.colors.text};
  border-radius: 50%;
  background: none;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  @media ${device.desktop} {
    top: 10px;
    right: 10px;
    width: 30px;
    height: 30px;
  }
`;

export const CloseButton = styled.img`
  width: 20px;
  color: ${themes.colors.border};
  @media ${device.desktop} {
    width: 30px;
  }
`;
